import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { AddContentToShowDocument } from './add-content.generated';

export const useAddContentToShow = (options: ApiOptions<typeof AddContentToShowDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(AddContentToShowDocument, {
    ...useNotifications(AddContentToShowDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        t('api.shows.add_content_success_plural', {
          count: data.addContentToShow?.addedIds.length ?? 0,
        }),
    }),

    ...options,
  });
};
